import { ActionType } from "../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { DecisionMakerClient } from "../../../../Wrap/Api/Account/DecisionMaker";
import { InvestmentPermissionClient } from "../../../../Wrap/Api/Account/InvestmentPermission";
import { BankAccountInstructionClient } from "../../../../Wrap/Api/BankAccounts/BankAccountInstruction";
import { AssetClassesClient } from "../../../../Wrap/Api/Instruments/AssetClasses";
import { AvailableSectorsClient } from "../../../../Wrap/Api/Instruments/AvailableSectors";
import { ExchangeTradedInstrumentSearchQueryClient } from "../../../../Wrap/Api/Instruments/ExchangeTradedInstrumentSearchQuery";
import { FavouriteProductsClient } from "../../../../Wrap/Api/Instruments/FavouriteProducts";
import { FundManagersClient } from "../../../../Wrap/Api/Instruments/FundManagers";
import { ExternalAssetsQuery } from "../../../../Wrap/Models/Domains/Investment/ExternalAssetsQuery";
import { ExternalAssetsSearchClient } from "../../../../Wrap/Api/Instruments/ExternalAssetsSearch";
import { ExternalManagersClient } from "../../../../Wrap/Api/Instruments/ExternalManagers";
import { SecuritySubTypesClient } from "../../../../Wrap/Api/Instruments/SecuritySubTypes";
import { FundProductsSearchClient } from "../../../../Wrap/Api/Instruments/FundProductsSearch";
import { DepositProductsSearchClient } from "../../../../Wrap/Api/Instruments/DepositProductsSearch";
import { InstrumentSearchQueryClient } from "../../../../Wrap/Api/Instruments/InstrumentSearchQuery";
import { InstrumentsValuationQueryClient } from "../../../../Wrap/Api/Instruments/InstrumentsValuationQuery";
import { ModelPortfolioManagersClient } from "../../../../Wrap/Api/Instruments/ModelPortfolioManagers";
import { ModelPortfolioProductClient } from "../../../../Wrap/Api/Instruments/ModelPortfolioProduct";
import { ModelPortfolioSearchQueryClient } from "../../../../Wrap/Api/Instruments/ModelPortfolioSearchQuery";
import { AccountAdviceType } from "../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { CurrencyCode } from "../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { AssetClassType } from "../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ModelPortfolioTabType } from "../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { ExchangeTradedInstrumentSearchQuery } from "../../../../Wrap/Models/Domains/Investment/ExchangeTradedInstrumentSearchQuery";
import { FundProductsQuery } from "../../../../Wrap/Models/Domains/Investment/FundProductsQuery";
import { DepositProductsQuery } from "../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { Instrument } from "../../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { ModelPortfolioSearchQuery } from "../../../../Wrap/Models/Domains/ModelPortfolio/ModelPortfolioSearchQuery";
import { ModelPortfolio } from "../../../../Wrap/Models/Models/Instruments/ModelPortfolio";
import { TransferISTSelection } from "../../../../Wrap/Models/Models/InstrumentSelection/TransferISTSelection";
import { Investment } from "../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import {
    ResearchISTDispatcher,
    ResearchISTStore,
} from "../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";
import { initInstrumentSelection } from "../Components/Shared/Utils";
import { AllocationTableItem } from "../Store/SelectedInvesmentStoreStatic";
import { ReRegTransferDispatcher, SelectedInvestmentDispatcher, SelectedInvestmentStore } from "../Store/Variable";
import { SDRLabelClient } from "../../../../Wrap/Api/Instruments/SDRLabel";
import { SdrLabelModel } from "../../../../Wrap/Models/Models/Instruments/SdrLabelModel";

export class InvestmentSelectionAction {
    public static addInvestment(
        investment: Instrument,
        modelPortfolioType?: ModelPortfolioTabType,
        hiercharyId?: string,
        canBeBought?: boolean
    ) {
        ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: [investment] });
        const isUnderTranfser = SelectedInvestmentStore.getIsUnderTransfer();
        if (isUnderTranfser) {
            return this.addUnderTransfer(investment, modelPortfolioType, hiercharyId, canBeBought);
        }
        let newItem: AllocationTableItem;
        if (modelPortfolioType) {
            if (modelPortfolioType == ModelPortfolioTabType.AdviserModel) {
                return this.getUnderlyingForAdviserPortifolio(
                    investment.ProductId,
                    modelPortfolioType,
                    hiercharyId,
                    canBeBought,
                    (underlyings: ModelPortfolio) => {
                        const _underlyings: AllocationTableItem[] = underlyings.ModelPortfolioProducts.map((ele) => ({
                            Instrument: {
                                ProductId: ele.ProductId,
                                Name: ele.Name,
                                AssetClass: ele.AssetClass,
                                AssetClassT2: ele.AssetClassT2,
                                FinexDocumentUrl: ele.FinexDocumentUrl,
                                Type: ele.ProductType,
                                ProductCode: ele.ProductCode,
                                DividendReinvestment: ele.DividendReinvestment,
                                Allocation: ele.Allocation
                            },
                            Single: {
                                Money: { Amount: null, Currency: CurrencyCode.GBP },
                                Percentage: Number(ele.Allocation.toFixed(2)),
                            },
                            ClientRegular: {
                                Money: { Amount: null, Currency: CurrencyCode.GBP },
                                Percentage: Number(ele.Allocation.toFixed(2)),
                            },
                            ThirdPartyRegular: {
                                Money: { Amount: null, Currency: CurrencyCode.GBP },
                                Percentage: Number(ele.Allocation.toFixed(2)),
                            },
                            EmployerRegular: {
                                Money: { Amount: null, Currency: CurrencyCode.GBP },
                                Percentage: Number(ele.Allocation.toFixed(2)),
                            },
                            Transfer: {
                                Money: { Amount: null, Currency: CurrencyCode.GBP },
                                Percentage: Number(ele.Allocation.toFixed(2)),
                            },
                            PostTransfer: {
                                Money: { Amount: null, Currency: CurrencyCode.GBP },
                                Percentage: Number(ele.Allocation.toFixed(2)),
                            },
                            allocation: Number(ele.Allocation.toFixed(2)),
                        }));
                        SelectedInvestmentDispatcher.dispatch({
                            actionType: ActionType.Replace,
                            payload: _underlyings,
                        });
                    }
                );
            }
            newItem = {
                allocation: null,
                needToggle: true,
                isPortfolio: true,
                modelPortfolioType: modelPortfolioType,
                ...initInstrumentSelection(investment),
            };
        } else {
            newItem = { allocation: null, ...initInstrumentSelection(investment) };
        }
        SelectedInvestmentDispatcher.dispatch({ actionType: ActionType.Success, payload: [newItem] });
    }

    public static addInvestments(investment: Instrument[]) {
        const isUnderTranfser = SelectedInvestmentStore.getIsUnderTransfer();
        if (isUnderTranfser) {
            return this.addInvestmentsForTransferIn(investment, null);
        }
        const newItem: AllocationTableItem[] = investment.map((ele) => ({
            allocation: null,
            ...initInstrumentSelection(ele),
        }));
        SelectedInvestmentDispatcher.dispatch({ actionType: ActionType.Success, payload: newItem });
    }

    public static addUnderTransfer(
        investment,
        modelPortfolioType: ModelPortfolioTabType,
        hierarchyId: string,
        canBeBought: boolean
    ) {
        if (investment == null) {
            SelectedInvestmentDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: [],
            });
        };

        if (!modelPortfolioType) {
            return this.addInvestmentForTransferIn(investment);
        }
        if (modelPortfolioType == ModelPortfolioTabType.AdviserModel && investment != null) {
            return this.getUnderlyingForAdviserPortifolio(
                investment.ProductId,
                modelPortfolioType,
                hierarchyId,
                canBeBought,
                (underlyings: ModelPortfolio) => {
                    if (underlyings.ModelPortfolioProducts.length > 0) {
                        this.addInvestmentsForTransferIn(
                            underlyings.ModelPortfolioProducts,
                            ModelPortfolioTabType.AdviserModel
                        );
                    }
                }
            );
        }
        if (modelPortfolioType == ModelPortfolioTabType.HubModel && investment != null) {
            const newItem = {
                allocation: null,
                needToggle: true,
                isPortfolio: true,
                modelPortfolioType: modelPortfolioType,
                Investment: {
                    ...investment,
                    ProductCode: investment.ProductCode || "M_" + investment.PortfolioId,
                    InstrumentCode: investment.ProductCode || "M_" + investment.PortfolioId,
                },
            };
            SelectedInvestmentDispatcher.dispatch({ actionType: ActionType.Success, payload: [newItem] });
        }
    }

    public static addInvestmentsForTransferIn(investments, modelType) {
        const client = new InstrumentsValuationQueryClient();
        const promise = client.get(
            investments.map((ele) => ele.ProductCode),
            JsonDateParser.toJsonDateNoOffset(new Date())
        );
        promise.onSuccess((result) => {
            const newItem: TransferISTSelection[] = investments.map((investment) => {
                const obj = result.find((item) => item.InstrumentCode == investment.ProductCode);
                return {
                        Units: 0,
                        ModelType: modelType,
                        Investment: {
                            DisplayName: investment.Name,
                            Type: investment.ProductType,
                            AssetClass: investment.AssetClass,
                            UnitPrice: obj?.ValuationPoint.Value,
                            Allocation: investment.Allocation,
                            ProductId: investment.ProductId,
                            ProductCode: investment.ProductCode,
                        },
                };
            });
            SelectedInvestmentDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: newItem.filter((ele) => ele !== null),
            });
        });
    }

    public static addInvestmentForTransferIn(investment: Instrument) {
        const client = new InstrumentsValuationQueryClient();
        const promise = client.get([investment?.ProductCode], JsonDateParser.toJsonDateNoOffset(new Date()));
        promise.onSuccess((result) => {
            const newItem: any = {
                Units: 0,
                IsFromExtraSearch: true,
                Investment: {
                    ProductId: investment.ProductId,
                    InstrumentCode: investment.ProductCode,
                    ProductCode: investment.ProductCode,
                    DisplayName: investment.Name,
                    Type: investment.Type,
                    AssetClass: investment.AssetClass,
                    UnitPrice: result[0]?.ValuationPoint.Value,
                    InsuredFund: investment.InsuredFund,
                },
            };
            SelectedInvestmentDispatcher.dispatch({ actionType: ActionType.Success, payload: [newItem] });
        });
    }

    public static getUnitPrice(investment: Instrument, callback, unitCost?) {
        const client = new InstrumentsValuationQueryClient();
        const promise = client.get([investment.ProductCode], JsonDateParser.toJsonDateNoOffset(new Date()));
        promise.onSuccess((result) => {
            const newItem: Investment = {
                UnitCost: unitCost || result?.[0]?.ValuationPoint.Value,
                UnitPrice: result?.[0]?.ValuationPoint.Value,
                InstrumentCode: investment.ProductCode,
                ProductId: investment.ProductId,
                Type: investment.Type,
                AssetClass: investment.AssetClass,
                DisplayName: investment.Name,
            };
            callback(newItem);
        });
    }

    public static getUnderlying(ProductId, modelPortfolioType, callback) {
        const client = new ModelPortfolioProductClient();
        const promise = client.get(ProductId, modelPortfolioType, null, null);

        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getSdrUrls(callback: (val: SdrLabelModel[]) => void): void {
        const client = new SDRLabelClient();
        const promise = client.get();

        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getUnderlyingForAdviserPortifolio(
        ProductId,
        modelPortfolioType,
        hiercharyId: string,
        canBeBought: boolean,
        callback
    ) {
        const client = new ModelPortfolioProductClient();
        const promise = client.get(ProductId, modelPortfolioType, hiercharyId, canBeBought);

        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getInvestmentPermission(servicePropositionId: number, callback) {
        const client = new InvestmentPermissionClient();
        const promise = client.get(servicePropositionId);

        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static searchInstruments(searchParams: InstrumentSearchQuery, hierarchyId: string, callback) {
        const client = new InstrumentSearchQueryClient();
        const promise = client.post(searchParams, hierarchyId);

        promise.onSuccess((data) => {
            callback(data.Results);
        });
        promise.onError((err) => {});
    }

    public static searchFundProducts(searchParams: FundProductsQuery, hierarchyId: string, callback, num?) {
        const client = new FundProductsSearchClient();
        searchParams.ResultsPerPage = num || 10;
        const promise = client.post(searchParams, hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError((err) => {});
    }

    public static searchDepositProducts(searchParams: DepositProductsQuery, hierarchyId: string, callback, num?) {
        const client = new DepositProductsSearchClient();
        searchParams.ResultsPerPage = searchParams.ProductIds?.length > 0 ? searchParams.ProductIds.length : num || 10;
        const promise = client.post(searchParams, hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError((err) => {});
    }

    public static searchExternalAssets(searchParams: ExternalAssetsQuery, hierarchyId: string, callback, num?) {
        const client = new ExternalAssetsSearchClient();
        searchParams.ResultsPerPage = num || 10;
        const promise = client.post(searchParams, hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError((err) => { });
    }

    public static getSectors(callback) {
        const client = new AvailableSectorsClient();
        const promise = client.get();

        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getAssetClasses(hierarchyId: string, assetClassType: AssetClassType, callback) {
        const client = new AssetClassesClient();
        const promise = client.get(assetClassType, hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static getFundManager(hierarchyId: string, callback) {
        const client = new FundManagersClient();
        client.get(hierarchyId).onSuccess((data) => {
            callback(data);
        });
    }

    public static getInvestmentManager(hierarchyId: string, callback) {
        const client = new ModelPortfolioManagersClient();
        client.get(hierarchyId).onSuccess((data) => {
            callback(data);
        });
    }

    public static getExternalManager(hierarchyId: string, callback) {
        const client = new ExternalManagersClient();
        client.get(hierarchyId).onSuccess((data) => {
            callback(data);
        });
    }

    public static getSecuritySubTypes(hierarchyId: string, securityType: string, callback) {
        const client = new SecuritySubTypesClient();
        client.get(hierarchyId, securityType).onSuccess((data) => {
            callback(data);
        });
    }

    public static searchHubPortfolio(query: ModelPortfolioSearchQuery, id, callback) {
        const client = new ModelPortfolioSearchQueryClient();
        query.ResultsPerPage = 10;
        const promise = client.post(query, id);

        promise.onSuccess((data) => {
            const _data = JSON.parse(JSON.stringify(data));
            _data.Results = data.Results.map((ele) => {
                return {
                    underlying: {
                        ModelPortfolioProducts: ele.ModelPortfolioProducts ? ele.ModelPortfolioProducts : [],
                    },
                    modelPortfolioType: ModelPortfolioTabType.HubModel,
                    ...ele,
                };
            });
            callback(_data);
        });
        promise.onError((err) => {});
    }

    public static searchExchangedTrade(query: ExchangeTradedInstrumentSearchQuery, hierarchyId: string, callback) {
        const client = new ExchangeTradedInstrumentSearchQueryClient();
        query.ResultsPerPage = 10;
        const promise = client.post(query, hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static searchExternalAsset(query: ExternalAssetsQuery, hierarchyId: string, callback) {
        const client = new ExchangeTradedInstrumentSearchQueryClient();
        query.ResultsPerPage = 10;
        const promise = client.post(query, hierarchyId);

        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => { });
    }

    public static setFavouriteProdcut(productId: number, isFavourite: boolean) {
        const client = new FavouriteProductsClient();
        const promise = client.put(productId, isFavourite);

        promise.onSuccess((data) => {});
        promise.onError((err) => {});
    }

    public static setIsUnderTransfer(v: boolean) {
        SelectedInvestmentDispatcher.dispatch({ actionType: ActionType.Update, payload: v });
    }

    public static setEditingTransferNumber(v: number) {
        ReRegTransferDispatcher.dispatch({ actionType: ActionType.Success, payload: v });
    }

    public static getDecisionMakers(hierarchyId: string, callback) {
        const client = new DecisionMakerClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            callback(data);
        });
    }
}
